// extracted by mini-css-extract-plugin
export var textInput = "_g1-0";